// import appLocaleData from 'react-intl/locale-data/zh';
import enMessages from './lang/ar-EG.json';
import antdAr from 'antd/lib/locale-provider/ar_EG'; //antd语言包
// console.log(1111,appLocaleData)
let appLocale = {
  messages: {
    ...enMessages,
  },
  antd: antdAr,
  locale: 'ar-EG',
  // data: appLocaleData,
};

export default appLocale;
